export default __webpack_public_path__ + "static/media/wQ.c5881644.png";